'use client';

import { type FC, useCallback } from 'react';

import { Box } from '@chakra-ui/react';
import { useStore } from '@nanostores/react';

import { SIZES } from '@app/constants';
import { useResetApp } from '@app/hooks';

import { AppNavigation, Layout } from '@widgets/app_header';

import { useHeaderScrollControl } from '@features/app_header';
import { useSignOut } from '@features/auth';
import { UserMenu } from '@features/user_menu';

import { $appHeaderStore } from '@entities/app_header';

import { Flex, Logo } from '@shared/ui-kit';

interface Props {
  variant: 'auth' | 'private' | 'public';
}

const AppHeader: FC<Props> = ({ variant }) => {
  const signOut = useSignOut();
  const { trigger } = useResetApp();
  const { isShow } = useStore($appHeaderStore);

  const isUnauthorized = variant === 'auth';

  useHeaderScrollControl();

  const onSignOut = useCallback(() => {
    signOut();
    trigger();
  }, []);

  if (isUnauthorized) {
    return (
      <Box
        w="full"
        h="header"
      />
    );
  }

  return (
    <Flex
      className="app-header"
      as="header"
      flexGrow="0"
      alignItems="center"
      boxShadow="base"
      pos="sticky"
      left="0"
      right="0"
      top="0"
      bg="white"
      w="full"
      h="header"
      zIndex="header"
      transform={`translateY(${isShow ? 0 : -SIZES.header}px)`}
      transition="all .15s ease-in"
    >
      <Layout
        logo={<Logo />}
        profile={<UserMenu onSignOut={onSignOut} />}
        nav={<AppNavigation />}
      />
    </Flex>
  );
};

export default AppHeader;
